import {IPageObserverEntry} from '../../Utilities/Helper.client';

const topNavEl: HTMLDivElement | null = document.querySelector('.top-nav');
const topLogo: HTMLDivElement | null = document.querySelector('.topLogoContainer');
const topNavObserverEl: HTMLElement | null = document.querySelector('.TopNavObserver');

const getWindowScroll = (): number => {
   if (typeof window.scrollY !== 'undefined') {
       return window.scrollY;
   }

   return window.pageYOffset;
}

export const toggleTopNavStyling = (bgChange?: boolean): void => {
    if (topNavEl === null || topLogo === null) {
        return;
    }

    // Subtract topNav height to prevent overlap when scrolled
    const isScroll: boolean = getWindowScroll() > (topNavEl.clientHeight - 30);

    if (isScroll === true) {
        bgChange === true && topNavEl.classList.add('bg-blue-400');
        topLogo.classList.add('md:max-w-210');
    } else {
        bgChange === true && topNavEl.classList.remove('bg-blue-400');
        topLogo.classList.remove('md:max-w-210');
    }
}

export const toggleTopNavLogo = (): void => {
    if (topNavEl === null || topLogo === null || window.innerWidth >= 768) {
        return;
    }

    if (getWindowScroll() > topNavEl.clientHeight) {
        topLogo.classList.remove('xs:invisible');
    } else {
        topLogo.classList.add('xs:invisible');
    }
}

export const topNavObserver = (callback: () => void): IPageObserverEntry | null => {
    if (topNavObserverEl === null) {
        return topNavObserverEl;
    }

    return {
        element: topNavObserverEl,
        callback: () => {
            window.requestIdleCallback(() => {
                callback();
            }, { timeout: 1000 })
        },
        threshold: [0, 0.2, 0.8, 1]
    }
}
